import { Box, Skeleton, type SxProps, type Theme } from "@mui/material";
import { AppConfig } from "../interfaces/appIntegration.interfaces";
import { StatusChip } from "./StatusChip";
import { PricingChip } from "./PrincingChip";
import { AppCardRoot, AppIcon, AppTitle, AppDescription, CategoryChip, type AppCardVariant } from "./themes/appCard";
import { useGetAppIntegrationStatus } from "../hooks/useGetAppIntegrationStatus";
import { AppState } from "../types/appIntegration.types";

interface Props {
  app: AppConfig;
  onClick?: () => void;
  cardVariant?: AppCardVariant;
  sx?: SxProps<Theme>;
}

export const AppCard = ({ app, onClick, cardVariant = "default", sx }: Props) => {
  const { data: status = "not_installed" as AppState, isLoading } = useGetAppIntegrationStatus(app);

  return (
    <AppCardRoot onClick={onClick} cardVariant={cardVariant} sx={{ maxWidth: { xs: "98%" }, ...sx }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <AppIcon src={app.icon} alt={app.name} cardVariant={cardVariant} />
          <AppTitle cardVariant={cardVariant}>{app.name}</AppTitle>
        </Box>
        {cardVariant === "payment" ? null : isLoading ? (
          <Skeleton variant="rounded" width={72} height={22} animation="wave" sx={{ borderRadius: 1 }} />
        ) : (
          <StatusChip status={status} />
        )}
      </Box>

      {cardVariant === "payment" ? null : <AppDescription cardVariant={cardVariant}>{app.mediumDescription}</AppDescription>}

      {cardVariant === "default" ? (
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {/* <PricingChip pricing={app.pricing} /> */}
          <CategoryChip label={app.category} variant="outlined" cardVariant={cardVariant} />
        </Box>
      ) : null}
    </AppCardRoot>
  );
};
